<template>       
  <v-layout text-xs-center wrap>
    <v-flex xs12 mt-4>
      <v-img
        :src="require('@/assets/img/brand.jpg')"
        class="my-3"
        contain
        height="80"
      ></v-img>
    </v-flex>          
    <v-flex mb-4>            
      <h1 class="display-1 font-weight-bold mb-3">
        Hasil Ujian tulis
      </h1>      
      <v-alert style="width:500px" class="mb-3" :value="true" color="info" icon="info" outline>
        Anda belum mengikuti ujian tulis / hasil ujian tulis anda belum diumumkan. info lebih lanjut hubungi panitia PPDB.
      </v-alert>     
    </v-flex>    
  </v-layout>        
</template>
<script>
export default {
  name:'step6',  
  components: { 
  },
  data:()=>({    
  }),
  computed: {},  
};
</script>


